import { render, staticRenderFns } from "./AnimeListView.vue?vue&type=template&id=77bf2cbe&"
import script from "./AnimeListView.vue?vue&type=script&lang=ts&"
export * from "./AnimeListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports